import { Box, styled } from '@mui/material';

export const Panel = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '8px',
  overflow: 'initial',
  contain: 'layout',
  isolation: 'isolate',
  // Containing block for the column's absolutely positioned LoadingOverlay.
  // Strictly redundant — `contain: layout` above already makes this element one —
  // but stated explicitly so the overlay doesn't escape to an ancestor if that
  // containment is ever relaxed for unrelated reasons.
  position: 'relative'
});
